import React from 'react';
import { Link } from 'react-router-dom';
import {
  Car,
  LayoutGrid,
  CalendarDays,
  Wallet,
  Settings,
  LogOut
} from 'lucide-react';
import BrandLogo from '../ui/BrandLogo';
import { authService, hasCapability } from '../../services/auth.service';

const Sidebar = ({ activePage }) => {
  const firstName = localStorage.getItem('firstName') || '';
  const lastName = localStorage.getItem('lastName') || '';
  const fullName = `${firstName} ${lastName}`.trim() || 'Owner';
  const initials = `${firstName[0] || ''}${lastName[0] || ''}`.trim() || `${fullName[0] || 'O'}`;

  const navItems = [
    ...(hasCapability('DRIVER') ? [{ name: 'Driver Dashboard', icon: <LayoutGrid className="w-5 h-5" />, path: '/driver-dashboard' }] : []),
    { name: 'Driver Portal', icon: <CalendarDays className="w-5 h-5" />, path: '/driver' },
    { name: 'Driver Trips', icon: <CalendarDays className="w-5 h-5" />, path: '/driver-trips' },
    { name: 'Dashboard', icon: <LayoutGrid className="w-5 h-5" />, path: '/owner-dashboard' },
    { name: 'Fleet', icon: <Car className="w-5 h-5" />, path: '/fleet' },
    { name: 'Bookings', icon: <CalendarDays className="w-5 h-5" />, path: '/owner/bookings' },
    { name: 'Financials', icon: <Wallet className="w-5 h-5" />, path: '/finances' },
  ];

  return (
    <aside className="w-20 lg:w-64 bg-brand-black text-white flex flex-col h-full shrink-0">
      <div className="p-4 lg:p-6">
        <Link to="/" aria-label="Go Rides home"><span className="hidden lg:block"><BrandLogo theme="light" size="md" /></span><span className="lg:hidden"><BrandLogo compact size="md" /></span></Link>
      </div>

      <nav className="flex-grow px-4 space-y-2">
        {navItems.map(item => {
          const isActive = activePage === item.name;
          return (
            <Link
              key={item.name}
              aria-label={item.name}
              to={item.path}
              className={`w-full flex items-center gap-3 justify-center lg:justify-start px-3 py-3 rounded-xl transition-all font-bold text-sm ${
                isActive
                  ? 'bg-brand-orange-700 text-white border border-brand-orange-600 shadow-lg'
                  : 'text-gray-400 hover:text-brand-orange-300 hover:bg-white/5'
              }`}
            >
              {item.icon}
              <span className="hidden lg:inline">{item.name}</span>
            </Link>
          );
        })}
      </nav>

      <div className="px-4 py-6 mt-auto border-t border-white/5 space-y-4">
        <Link
          aria-label="Settings"
          to="/account/settings"
          className={`w-full flex items-center gap-3 justify-center lg:justify-start px-3 py-3 rounded-xl transition-all font-bold text-sm ${
            activePage === 'Settings'
              ? 'bg-brand-orange-700 text-white border border-brand-orange-600 shadow-lg'
              : 'text-gray-400 hover:text-brand-orange-300 hover:bg-white/5'
          }`}
        >
          <Settings className="w-5 h-5" />
          <span className="hidden lg:inline">Settings</span>
        </Link>

        <div className="hidden lg:flex items-center gap-3 px-2">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-brand-orange-700 to-brand-orange-600 flex items-center justify-center font-black text-xs text-brand-black">
            {initials.toUpperCase()}
          </div>
          <div className="flex-grow">
            <p className="text-xs font-black">{fullName}</p>
            <p className="text-[9px] uppercase font-bold text-gray-500 tracking-wider">Car owner</p>
          </div>
          <button
            aria-label="Log out"
            onClick={authService.logout}
            className="text-gray-500 hover:text-red-400 transition-colors"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
